import { useEffect } from 'react';

// Build-time prerendering (scripts/prerender-routes.cjs) waits for the data a
// marketing page shows before saving its HTML. Each data source reports its state
// as data-prerender-<key>="loading|ready|empty|error" on <html>. The attribute has
// no effect for visitors.
export function getPrerenderState({ loading = false, error = null, isEmpty = false } = {}) {
  if (loading) return 'loading';
  if (error) return 'error';
  return isEmpty ? 'empty' : 'ready';
}

export function usePrerenderReadiness(key, status) {
  const state = getPrerenderState(status);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute(`data-prerender-${key}`, state);
  }, [key, state]);

  useEffect(() => () => {
    if (typeof document === 'undefined') return;
    document.documentElement.removeAttribute(`data-prerender-${key}`);
  }, [key]);
}
